const DOCUMENT_STATUSES = {
  rejected: 'rejected',
  pending: 'pending',
  verified: 'verified'
} as const

export {DOCUMENT_STATUSES}
